class HbHotspots extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  onKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const trigger = event.target.closest('[data-hb-hotspot-trigger]');
    if (!trigger) return;
    event.preventDefault();
    this.activate(trigger);
  }

  onClick(event) {
    const trigger = event.target.closest('[data-hb-hotspot-trigger]');
    if (!trigger) return;
    this.activate(trigger);
  }

  activate(trigger) {
    const targetId = trigger.getAttribute('aria-controls');
    const target = targetId ? this.querySelector(`#${CSS.escape(targetId)}`) : null;
    if (!target) return;

    this.querySelectorAll('[data-hb-hotspot-card]').forEach((card) => {
      card.hidden = card !== target;
    });

    this.querySelectorAll('[data-hb-hotspot-trigger]').forEach((button) => {
      button.setAttribute('aria-expanded', button === trigger ? 'true' : 'false');
    });
  }
}

if (!customElements.get('hb-hotspots')) {
  customElements.define('hb-hotspots', HbHotspots);
}
